const { default: axiosIns } = require('@/libs/axios')

const AudiencesService = {
  // GET - AudienceApiController
  async getAudiences(page, name, status, accountId) {
    return axiosIns.get(`/audience?accountId=${accountId}`, {
      params: {
        page,
        name,
        status,
      },
    }).then(response => response.data)
  },
  // DELETE - AudienceApiController
  async deleteAudience(id, accountId) {
    return axiosIns.delete(`/audience/${id}?accountId=${accountId}`).then(response => response.data)
  },
}

export default AudiencesService
